import { Box, Card, CardContent, Grid, Typography } from '@mui/material'
import { PeopleAlt, CheckCircle, Cancel, Error } from '@mui/icons-material'
import { fontSizes, fontWeights } from '../../../Common/Typography/TypographyStyles'
import { useAppSelector } from '../../../../redux/store'
import { selectFilteredInvitedTeamMembersCount } from '../../../../redux/reports/event/invitedTeamMemberPerEvent/selector'
import { Stack } from '@mui/system'

const EventAttendeesChart = () => {
  const data = useAppSelector(selectFilteredInvitedTeamMembersCount)

  const attendanceData = [
    {
      label: 'Invited Team Members',
      value: data.totalInvited || 0,
      background: 'linear-gradient(90deg, #1CB5E0 0%, #000851 100%)', // Blue gradient
      Icon: PeopleAlt,
    },
    {
      label: 'Registered Team Members',
      value: data.registered.count || 0,
      valuePercentage: data.registered.percentage || 0,
      background: 'linear-gradient(90deg, #9ebd13 0%, #008552 100%)', // Green gradient
      Icon: CheckCircle,
    },
    {
      label: 'Non-Registered Team Members',
      value: data.unregistered.count || 0,
      valuePercentage: data.unregistered.percentage || 0,
      background: 'linear-gradient(90deg, #d53369 0%, #daae51 100%)', // Red gradient
      Icon: Cancel,
    },
    {
      label: 'Target Compliance',
      value: (data?.targetCompliance ?? 0) + '%',
      background: 'linear-gradient(90deg, #FDBB2D 0%, #3A1C71 100%)', // Yellow gradient
      Icon: Error,
    },
  ]

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
      <Grid container spacing={2} sx={{ width: '100%' }}>
        {attendanceData.map((item) => (
          <Grid size={{ xs: 12, sm: 6, md: 3 }} key={item.label}>
            <Card
              sx={{
                background: item.background,
                color: 'white',
                borderRadius: fontSizes.size12,
                padding: 0,
              }}
            >
              <CardContent>
                <Box display='flex' alignItems='center' justifyContent='space-between'>
                  <Typography
                    sx={{
                      fontSize: { xs: fontSizes.size12, md: fontSizes.size16 },
                      fontWeight: fontWeights[500],
                      textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                    }}
                  >
                    {item.label}
                  </Typography>

                  <item.Icon
                    sx={{
                      fontSize: {
                        xs: fontSizes.size28,
                        md: fontSizes.size36,
                      },
                      textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                    }}
                  />
                </Box>
                <Stack direction='row' alignItems='center' spacing={1}>
                  <Typography
                    sx={{
                      fontSize: { xs: fontSizes.size16, md: fontSizes.size32 },
                      fontWeight: fontWeights[500],
                      textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                    }}
                  >
                    {item.value.toLocaleString()}
                  </Typography>
                  {item.valuePercentage !== undefined && (
                    <Typography
                      sx={{
                        fontSize: { xs: fontSizes.size12, md: fontSizes.size16 },
                        fontWeight: fontWeights[500],
                        textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                      }}
                    >
                      {item.valuePercentage}%
                    </Typography>
                  )}
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

export default EventAttendeesChart
